export const handleClicks = false;

export const convertToNumber = (value) => {
	const parsed = typeof value === "string" ? parseFloat(value) : value;
	if (typeof parsed === "number" && !Number.isNaN(parsed)) {
		return parsed;
	}
	return null;
};

export const getParentElement = (event) =>
	event.target.closest(".sg-visualization");
export const getSvgParentElement = (event) => event.target.closest("svg");

export const getElementsByClasses = (classes) => {
	const classNameArray = classes.split(" ");
	const elements = document.getElementsByClassName(classNameArray[0]);
	return [elements, classNameArray];
};

export const getAttrDataBase = (e) => {
	const val = e.getAttribute("data-base");
	return convertToNumber(val, "data-base");
};
export const getAttrDataId = (e) => {
	const val = e.getAttribute("data-id");
	return convertToNumber(val, "data-id");
};
export const getAttrDataSegment = (e) => {
	const val = e.getAttribute("data-segment");
	return convertToNumber(val, "data-segment");
};
export const getAttrDataClass = (e) => e.getAttribute("class");
export const getAttrDataLine = (e) => {
	const val = e.getAttribute("data-line");
	return convertToNumber(val, "data-line");
};
export const getAttrDataCutLocation = (e) => {
	const val = e.getAttribute("data-cut-location");
	return convertToNumber(val, "data-cut-location");
};

// code to get offset {top,left} in document coordinates of any element.
// see http://javascript.info/tutorial/coordinates
export const getOffsetRect = (elem) => {
	const box = elem.getBoundingClientRect();
	const { body } = document;
	const docElem = document.documentElement;
	const scrollTop = window.pageYOffset || docElem.scrollTop || body.scrollTop;
	const scrollLeft =
		window.pageXOffset || docElem.scrollLeft || body.scrollLeft;
	const clientTop = docElem.clientTop || body.clientTop || 0;
	const clientLeft = docElem.clientLeft || body.clientLeft || 0;
	const top = box.top + scrollTop - clientTop;
	const left = box.left + scrollLeft - clientLeft;
	return { top: Math.round(top), left: Math.round(left) };
};

// Gets the computed style is a browser cross platform way
// call as follows:
// get_style(document.getElementById("container"), "border-radius");
export const getStyle = (element, css3Prop) => {
	let strValue = "";
	if (window.getComputedStyle) {
		strValue = getComputedStyle(element).getPropertyValue(css3Prop);
	}
	// IE
	else if (element.currentStyle) {
		try {
			strValue = element.currentStyle[css3Prop];
		} catch (e) {
			// console.log(e);
		}
	}
	return strValue;
};

export const findNearestRelativePositionParent = (element) => {
	// check if we have relative position
	if (getStyle(element, "position") === "relative") {
		// found relative position
		return element;
	}
	// try parent
	if (element.parentNode == null) {
		return element;
	}
	if (element.parentNode.style != null) {
		return findNearestRelativePositionParent(element.parentNode);
	}
	return element;
};

export const findSequenceLineNumber = (e) => {
	// check if we have relative position
	const line = getAttrDataLine(e);
	if (line != null) return line;
	if (e.parentNode.style != null) return findSequenceLineNumber(e.parentNode);
	return null;
};

// Shows a tooltip in the correct position on an html page based on an SVG element.
//
// svgParentElement: svg element to base the position
// tipElement: tooltip to show
// over: an array of SVG elements to base the position.  The position will be the
//    outer extent of all the rectangles combined.
// showAbove: hint (true or false) to help with placement
// forEnzyme: rules for placement are slightly different for enzymes compared with
//    other elements.
//
export const showTooltipByElement = (
	svgParentElement,
	tipElement,
	over,
	showAbove,
	forEnzyme,
) => {
	const SHOW_ABOVE = !!(showAbove === "true" || showAbove === true);
	const FOR_ENZYME = typeof forEnzyme !== "undefined";
	const tooltipElement = tipElement;

	if (tooltipElement == null) return;

	const svgElements = tooltipElement.getElementsByTagName("svg");
	if (svgElements != null && svgElements.length !== 0) {
		const svgElement = svgElements[0];

		// The svg element <svg> needs a width and height of the actual calculated bounding
		// box which is hard to determine with the current code.  We will compute it here in
		// javascript and use it.
		if (svgElement.hasChildNodes()) {
			// const firstG = svgElement.childNodes[0];
			// const newElement = document.createElementNS("http://www.w3.org/2000/svg", "rect");
			const svgElementSize = svgElement.getBBox();

			// set svg size slightly larger to avoid the content getting clipped
			const w = `${svgElementSize.width + 10}px`;
			const h = `${svgElementSize.height + 3}px`;
			svgElement.style.width = w;
			svgElement.style.height = h;
		}
	}

	// evil hack to force chrome to relayout the tooltip window.  Otherwise it "over-optimizes" the need
	// to do the layout.
	tooltipElement.style.display = "none";
	tooltipElement.style.display = "block";

	const viewport = svgParentElement.closest(".viewport");
	// const mapWidth = viewport.clientWidth;
	// const mapHeight = viewport.clientHeight;
	//    console.log("viewport="+mapWidth + " " + mapHeight);

	// figure out the offset in document coordinates of the svg element.  I can
	// compute the offset by computing the position in using
	const mapBb = svgParentElement.getBBox();
	mapBb.x = 0;
	mapBb.y = 0;

	const svgMapCTM = svgParentElement.getScreenCTM();
	const mapLeftPt = svgParentElement.createSVGPoint();
	const mapRightPt = svgParentElement.createSVGPoint();
	mapLeftPt.x = mapBb.x;
	mapLeftPt.y = mapBb.y;
	mapRightPt.x = mapBb.x + mapBb.width;
	mapRightPt.y = mapBb.y + mapBb.height;
	const mapLeftTransPt = mapLeftPt.matrixTransform(svgMapCTM);
	// const mapRightTransPt = mapRightPt.matrixTransform(svgMapCTM);

	// transform the bounding box from the bottom left and bottom right
	let x1 = 0;
	let y1 = 0;
	let x2 = 0;
	let y2 = 0;
	for (let i = 0; i < over.length; i += 1) {
		const bb = over[i].getBBox();
		const overCTM = over[i].getScreenCTM(over[i]);
		const ptLeft = svgParentElement.createSVGPoint();
		const ptRight = svgParentElement.createSVGPoint();
		ptLeft.x = bb.x;
		ptLeft.y = bb.y;
		ptRight.x = bb.x + bb.width;
		ptRight.y = bb.y + bb.height;
		const toolLeftTransPt = ptLeft.matrixTransform(overCTM);
		const toolRightTransPt = ptRight.matrixTransform(overCTM);

		// add to results
		if (i === 0) {
			x1 = toolLeftTransPt.x - mapLeftTransPt.x;
			y1 = toolLeftTransPt.y - mapLeftTransPt.y;
			x2 = toolRightTransPt.x - mapLeftTransPt.x;
			y2 = toolRightTransPt.y - mapLeftTransPt.y;
		} else {
			x1 = Math.min(x1, toolLeftTransPt.x - mapLeftTransPt.x);
			y1 = Math.min(y1, toolLeftTransPt.y - mapLeftTransPt.y);
			x2 = Math.max(x2, toolRightTransPt.x - mapLeftTransPt.x);
			y2 = Math.max(y2, toolRightTransPt.y - mapLeftTransPt.y);
		}
	}

	const base = findNearestRelativePositionParent(svgParentElement);
	const baseRect = {
		left: 0,
		top: 0,
		width: base.clientWidth,
		height: base.clientHeight,
	};
	if (base != null) {
		const baseOffsetRect = getOffsetRect(base);
		baseRect.left += baseOffsetRect.left;
		baseRect.top += baseOffsetRect.top;
	}

	const viewportRect = {
		left: 0,
		top: 0,
		width: viewport.clientWidth,
		height: viewport.clientHeight,
	};
	{
		const viewportOffsetRect = getOffsetRect(viewport);
		viewportRect.left += viewportOffsetRect.left;
		viewportRect.top += viewportOffsetRect.top;
	}

	// transform hittest rectangle to base coordinates
	const hitRect = { left: x1, top: y1, width: x2 - x1, height: y2 - y1 };
	{
		const svgOffsetRect = getOffsetRect(svgParentElement);
		hitRect.left += svgOffsetRect.left;
		hitRect.top += svgOffsetRect.top;
	}

	//
	// Placement logic begin
	// Now, everything is in base coordinates: hitRect, viewportRect.  We also have tipWidth and tipHeight.
	// The placement logic determines were to put the tooltip by setting tipRect.
	//
	const tipRect = {
		left: 0,
		top: 0,
		width: tooltipElement.getBoundingClientRect().width,
		height: tooltipElement.getBoundingClientRect().height,
	};

	if (FOR_ENZYME) {
		// try to place in the upper right first --- if no room, go to upper left and shift down as necessary
		tipRect.left = hitRect.left + hitRect.width + 6;
		tipRect.top = hitRect.top - tipRect.height - 6;
		const roomRight =
			viewportRect.left + viewportRect.width > tipRect.left + tipRect.width;
		const roomUp = viewportRect.top < tipRect.top;

		if (roomUp && roomRight) {
			// it fits.  All done with placement.
		} else if (roomUp && !roomRight) {
			// no room to the right?  Slide left.
			tipRect.left = viewportRect.left + viewportRect.width - tipRect.width;
		} else if (!roomUp && roomRight) {
			// no room up, slide down
			tipRect.top = viewportRect.top;
		} else {
			// no room for either, place to the left and slide down
			tipRect.left = hitRect.left - tipRect.width - 6;
			tipRect.top = viewportRect.top;
		}
	} else {
		if (SHOW_ABOVE) {
			// try to place above
			tipRect.top = hitRect.top - tipRect.height - 6;
			if (tipRect.top < viewportRect.top) {
				// nevermind, too high.  Place below.
				tipRect.top = hitRect.top + hitRect.height + 6;
			}
		} else {
			// try to place below
			tipRect.top = hitRect.top + hitRect.height + 6;
			if (
				tipRect.top + tipRect.height >
				viewportRect.top + viewportRect.height
			) {
				// ok, do above then.
				tipRect.top = hitRect.top - tipRect.height - 6;
			}
		}

		// center horizontally
		tipRect.left = hitRect.left + hitRect.width / 2 - tipRect.width / 2;
		tipRect.left = Math.max(tipRect.left, viewportRect.left + 15);
		tipRect.left = Math.min(
			tipRect.left,
			viewportRect.left + viewportRect.width - tipRect.width - 15,
		);
	}

	//
	// Placement logic end
	//

	// the final coordinates need to be base coordinates (closest relative parent).
	tipRect.left -= baseRect.left;
	tipRect.top -= baseRect.top;

	tooltipElement.style.left = `${tipRect.left}px`;
	tooltipElement.style.top = `${tipRect.top}px`;
	tooltipElement.style.visibility = "visible";
};

export const hideTooltipByElement = (tool) => {
	const element = tool;
	if (element != null) {
		element.style.visibility = "hidden";
	}
};

export const hideTooltip = (tooltipId) => {
	const tool = document.getElementById(tooltipId);
	if (tool != null) {
		hideTooltipByElement(tool);
	}
};
